import { FC } from "react";
import { Paper, Typography, Box } from "@mui/material";
import {
	Area,
	AreaChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { ScoredSumPayload } from "../../../../../services/reports.service";

interface ScoredSumViewProps {
	payload: ScoredSumPayload;
}

const TEAL = "#1D9E75";

const ScoredSumView: FC<ScoredSumViewProps> = ({ payload }) => {
	const hasAnyData = payload.avgScoreByDay.some((d) => d.avgScore !== null);

	if (!hasAnyData) {
		return (
			<Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
				<Typography variant="body1" color="text.secondary">
					No submissions yet for this event in the selected window.
				</Typography>
			</Paper>
		);
	}

	return (
		<Paper variant="outlined" sx={{ p: 2 }}>
			<Box sx={{ width: "100%", height: 320 }}>
				<ResponsiveContainer width="100%" height="100%">
					<AreaChart
						data={payload.avgScoreByDay}
						margin={{ top: 12, right: 24, left: 12, bottom: 8 }}
					>
						<defs>
							<linearGradient id="scoredSumFill" x1="0" y1="0" x2="0" y2="1">
								<stop offset="0%" stopColor={TEAL} stopOpacity={0.45} />
								<stop offset="100%" stopColor={TEAL} stopOpacity={0.05} />
							</linearGradient>
						</defs>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis
							dataKey="day"
							type="number"
							domain={[1, 14]}
							ticks={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]}
						/>
						<YAxis domain={[payload.scoreMin, payload.scoreMax]} />
						<Tooltip
							formatter={(value) =>
								typeof value === "number" ? value.toFixed(1) : "—"
							}
							labelFormatter={(label) => `Day ${label}`}
						/>
						<Area
							type="monotone"
							dataKey="avgScore"
							stroke={TEAL}
							strokeWidth={2}
							fill="url(#scoredSumFill)"
							connectNulls={false}
							isAnimationActive={false}
						/>
					</AreaChart>
				</ResponsiveContainer>
			</Box>
		</Paper>
	);
};

export default ScoredSumView;
